function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M0,0H24V24H0Z",
  fill: "none"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M15.75,14.39l7.37,7.4-1.38,1.39-7.37-7.41A8.27,8.27,0,0,1,2.68,14.39,8.37,8.37,0,0,1,4.06,2.63,8.27,8.27,0,0,1,15.75,4a8.48,8.48,0,0,1,0,10.37ZM9.27,15.57A6.42,6.42,0,1,0,2.88,9.15,6.39,6.39,0,0,0,9.27,15.57Z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref, _ref2);
};

export default __webpack_public_path__ + "static/media/search-icon.98c7ade5.svg";
export { SvgComponent as ReactComponent };